module.exports = __webpack_public_path__ + "img/meterHardDifficulty.c2e9660.svg";